import { callAPI } from '../../../../services/api.service';

// Dev-only fixture tools (server: /admin/test-data/*). Every endpoint 401s in production —
// availability drives whether the sidebar shows the page at all.

export type TestDataScenario = 'class_pool' | 'ready_pool';

export interface BookValidation {
  ok: boolean;
  title?: string;
  isComplete?: boolean;
  hasPrintPdf?: boolean;
  reasons?: string[];
  error?: string;
}

export interface SeededStudent {
  name: string;
  loginName: string | null;
  email: string;
  password: string | null;
}

export interface ScenarioResult {
  ok?: boolean;
  message?: string;
  error?: string;
  runId?: string;
  teacher?: { email: string; password: string };
  students?: SeededStudent[];
  classroomId?: string | null;
  bookIds?: string[];
  orderNumbers?: string[];
}

export interface TestDataRun {
  id: string;
  scenario: TestDataScenario;
  createdAt: any;
  createdBy: string;
  teacherEmail: string;
  classroomId: string | null;
  students: number;
  books: number;
  orders: number;
  failed: boolean;
  error: string | null;
}

export const fetchTestDataAvailability = async (): Promise<boolean> => {
  try {
    const response = await callAPI('admin/test-data/availability', null, 'GET');
    return !!response?.enabled;
  } catch {
    return false;
  }
};

export const validateSourceBook = async (bookId: string): Promise<BookValidation> => {
  const response = await callAPI('admin/test-data/validate-book', { bookId });
  return response || { ok: false, error: 'No response from the server' };
};

export const runScenario = async (
  scenario: TestDataScenario,
  sourceBookId: string,
  count: number,
): Promise<ScenarioResult> => {
  const response = await callAPI('admin/test-data/scenario', { scenario, sourceBookId, count });
  return response || { ok: false, error: 'No response from the server — the run may still be finishing; refresh the runs list.' };
};

export const fetchRuns = async (): Promise<TestDataRun[]> => {
  const response = await callAPI('admin/test-data/runs', null, 'GET');
  return response?.runs || [];
};

export const deleteRun = async (runId: string): Promise<{ ok?: boolean; message?: string; error?: string }> => {
  const response = await callAPI(`admin/test-data/runs/${runId}/delete`, {});
  return response || { ok: false, error: 'No response from the server' };
};

export const sweepOrphans = async (): Promise<{ ok?: boolean; message?: string; error?: string }> => {
  const response = await callAPI('admin/test-data/sweep', {});
  return response || { ok: false, error: 'No response from the server' };
};
